
























































































































































































































































import { Component, Vue, Watch, Prop, PropSync, Ref } from 'vue-property-decorator';
import { Urls } from '@/Urls';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import { ResourceList, ListType } from '@/api/model/ResourceList';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import ChoiceListInput from '@/components/Lists/ChoiceListInput.vue';
import FactorListInput from '@/components/Lists/FactorListInput.vue';
import ViewpointListInput from '@/components/Lists/ViewpointListInput.vue';
import ChoiceListInputDialog from '@/components/Lists/ChoiceListInputDialog.vue';
import FactorListInputDialog from '@/components/Lists/FactorListInputDialog.vue';
import ViewpointListInputDialog from '@/components/Lists/ViewpointListInputDialog.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import Modelling from '@/store/modules/Modelling';
import { Factor, FactorGroup, FactorResource } from '@/api/model/FactorResource';
import FactorNavigation from '@/components/navigation/FactorNavigation.vue';
import Apps from '@/store/modules/Apps';
import _, { sortedIndex } from 'lodash';

const appsModule = getModule(Apps);
const decisionsModule = getModule(Decisions);
const workspaceModule = getModule(WorkspaceOptions);
const choicesModule = getModule(Choices);
const modellingModule = getModule(Modelling);
const viewpointsModule = getModule(Viewpoints);

@Component({
    components: {
        ChoiceListInput,
        FactorListInput,
        ViewpointListInput,
        ConfirmationDialog,
        CardTitle,
        ChoiceListInputDialog,
        FactorListInputDialog,
        ViewpointListInputDialog,
        FactorNavigation,
    },
})
export default class ListManager extends Vue {
    private items = [{value:'Choice', name: this.singularChoiceLabel}, {value: 'Factor', name: this.singularFactorLabel }, {value:'Viewpoint', name: this.singularViewpointLabel}];
    private panel = [];
    private alert = false;
    private alertText = 'Create';
    private alertType = 'success';
    private dialogDelTitle: any;
    private dialogDelMsg: any;
    private selectEditItem = {};
    private loading = false;

    private choiceSave = false;
    private factorSave = false;
    private viewpointSave = false;
    private choiceClear = false;
    private factorClear = false;
    private viewpointClear = false;

    private show = false;

    private showEditor = {
        Factor: false,
        Choice: false,
        Viewpoint: false,
    };

    private expanded = {
        Choice: [],
        Factor: [],
        Viewpoint: [],
    };

    @Prop({ default: false, type: Boolean })
    appEmbed!: boolean;

    // // dialog mapping base on the item
    // private dialogMapping: any = {
    //     Choice: ChoiceListInput,
    //     Factor: FactorListInput,
    //     Viewpoint: ViewpointListInput,
    // };

    // dictionary to control the vdialog

    mounted() {}

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get choices() {
        return choicesModule.unfilteredChoices;
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree('M');
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    editSelectItem(list, item) {
        // console.log(item);
        this.selectEditItem = item;
        this.showEditor[list] = true;
    }
    // get decision list from vuex decision module
    get lists() {
        const lists = _.values(decisionsModule.decisionLists);
        // console.log(lists);
        return lists;
    }

    get contributingFactors() {
        return viewpointsModule.contributingFactorResources;
    }

    get contributingVisibility() {
        return workspaceModule.contributingFactorVisibility;
    }

    get getCfvLists() {
        const cfvLists = {};
        // console.log(this.lists);
        cfvLists['Choice'] = this.lists
            .filter((list: any) => list.type === 'CHOICE')
            .map((res: any) => ({
                decisionId: res.decisionId,
                description: res.description,
                choices: res.choices,
                listId: res.listId,
                type: res.type,
                name: res.name,
                numChoices: res.choices.length,
            }));

        cfvLists['Viewpoint'] = this.lists
            .filter((list: any) => list.type === 'VIEWPOINT')
            .map((res: any) => ({
                decisionId: res.decisionId,
                description: res.description,
                viewpoints: res.viewpoints,
                listId: res.listId,
                type: res.type,
                name: res.name,
                numChoices: res.viewpoints.length,
            }));
        cfvLists['Factor'] = this.lists
            .filter((list: any) => list.type === 'FACTOR')
            .map((res: any) => ({
                decisionId: res.decisionId,
                description: res.description,
                factors: res.factors,
                listId: res.listId,
                type: res.type,
                name: res.name,
                numChoices: this.countFactors(res.factors),
            }));
        // console.log(cfvLists);

        return cfvLists;
    }

    private countFactors(factorList: any) {
        let ignoreFactorList = [];
        factorList.forEach((e: any) => {
            let factor = this.factorResources[e.factorId];
            if (factor && factor.groupTypeDefinition && factor.groupTypeDefinition.type) {
                if (
                    factor.groupTypeDefinition.type === 'TABLE_ROW' ||
                    factor.groupTypeDefinition.type === 'TABLE_COLUMN'
                ) {
                    ignoreFactorList.push(e.factorId);
                    if (factor.childrenIds && factor.childrenIds.length > 0) {
                        factor.childrenIds.forEach((c: string) => {
                            ignoreFactorList.push(c);
                        });
                    }
                }
            }
        });
        let counter = 0;
        factorList.forEach((e: any) => {
            // console.log(ignoreFactorList.indexOf(e.factorId));
            if (ignoreFactorList.indexOf(e.factorId) === -1) {
                counter++;
            }
        });
        // console.log(counter);
        return counter;
    }

    private getSortedChoiceList(list: any) {
        if (list && list.length > 0 && this.choices) {
            let sortedList = [];
            let i = 0;
            list.forEach((e) => {
                // console.log(this.choices[e.choiceId]);
                if(this.choices[e.choiceId]){
                    sortedList[i] = {};
                    sortedList[i].id = e.choiceId;
                    sortedList[i].name = this.choices[e.choiceId].name;
                    i++;
                }

            });
            // console.log(sortedList);
            sortedList = _.sortBy(sortedList, [
                (o) => {
                    return o.name.toLowerCase();
                },
            ]);
            return sortedList;
        }
    }

    // factorGroup.groupTypeDefinition.type === 'TABLE_GROWING'
    private getSubTree(factorResourceId: string): { id: string; name?: string; children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition &&
            factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
        ) {
            // childrenIds = factorGroup.childrenIds
            //     .map((f) => this.factorResources[f])
            //     .filter((f) => f)
            //     .filter(
            //         (f) =>
            //             f.type === 'FACTOR_GROUP' &&
            //             (f as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN'
            //     )
            //     .map((f) => f.id); // This will update the factor names to display correctly
            // let rows = factorGroup.childrenIds
            //     .map((f) => this.factorResources[f])
            //     .filter((f) => f) // contributing
            //     .filter(
            //         (f) =>
            //             f.type === 'FACTOR_GROUP' &&
            //             (f as FactorGroup).groupTypeDefinition.type === 'TABLE_ROW'
            //     ) as FactorGroup[];
            // for (let colId of childrenIds) {
            //     let column = this.factorResources[colId] as FactorGroup;
            //     if (!column) continue;
            //     column.childrenIds.forEach((id) => {
            //         let row = rows.find((r) => r.childrenIds.includes(id));
            //         if (row && this.factorResources[id]) {
            //             this.factorResources[id].name = row.name;
            //         }
            //     });
            // }
            childrenIds = [];
        } else {
            childrenIds = factorGroup.childrenIds || [];
        }
        // childrenIds = factorGroup.childrenIds || [];
        let children = childrenIds
            .filter((id) => this.contributingVisibility || this.contributingFactors[id])
            .filter((f) => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name,
                    };
                }
                return this.getSubTree(cId);
            });
        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children,
        };
    }

    private getFilteredTree(item, list) {
        // console.log(item);
        let filteredTree = {};
        if (list === 'Factor' && item.factors) {
            let filter = [];
            item.factors.forEach((e: any) => {
                filter.push(e.factorId);
            });
            this.createFilteredTree(this.factorResourceTree, filter, filteredTree);
            return filteredTree;
        }
        return {};
    }

    private copyObjectWithoutChildren(src, res) {
        const itemKeys = Object.keys(src);
        itemKeys.forEach((key) => {
            if (key !== 'children') {
                res[key] = src[key];
            }
        });
    }

    private createFilteredTree(tree, filters, filteredTree) {
        let found = false; // if it's an object, go through the children first // if it's array, loop through the array
        if (!Array.isArray(tree) && typeof tree === 'object') {
            if (!filteredTree) {
                filteredTree = {};
            } // check if has children, go through children first
            if (tree.hasOwnProperty('children') && tree.children && tree.children.length) {
                // loop through children, call this function for all the children
                let foundInChildren = false; // created the children property first, destory later
                filteredTree.children = [];
                let i = 0;
                tree.children.forEach((child) => {
                    // call the function itself to iterate/check
                    // push an empty object into the children array so the children could store the data
                    // if not found, use array.pop() to destory the new filteredchild object
                    let filteredChild = {};
                    filteredTree.children.push(filteredChild);
                    foundInChildren = this.createFilteredTree(
                        child,
                        filters,
                        filteredTree.children[i]
                    ); // if children has the correct id, increment i so the next object will have a different index // if not found, destory the new created child object
                    if (foundInChildren) {
                        i++;
                        found = true;
                    } else {
                        filteredTree.children.pop();
                    }
                }); // if children found the id, store the parent id &name // else delete the children property
                if (found) {
                    this.copyObjectWithoutChildren(tree, filteredTree);
                } else {
                    delete filteredTree.children;
                }
            } // check if the id is the correct id, record id&name if true
            if (filters.indexOf(tree.id) != -1) {
                this.copyObjectWithoutChildren(tree, filteredTree);
                found = true;
            } // else if the object is array, call the function itself to iterate through the array
        } else if (Array.isArray(tree)) {
            if (!filteredTree) {
                filteredTree = [];
            }
            for (let child of tree) {
                let newChild = {};
                let i = 0;
                filteredTree.push(newChild);
                let foundInChildren = false;
                foundInChildren = this.createFilteredTree(child, filters, filteredTree[i]);
                if (foundInChildren) {
                    i++;
                    found = true;
                } else {
                    filteredTree.children.pop();
                }
            }
        } // console.log(filteredTree);
        return found;
    }

    private getSortedViewpointList(list: any) {
        if (list && list.length > 0 && this.viewpoints) {
            let sortedList = [];
            let i = 0;
            list.forEach((e) => {
                // console.log(e.viewpointId);
                if(this.viewpoints[e.viewpointId]){
                    sortedList[i] = {};
                    sortedList[i].id = e.viewpointId;
                    sortedList[i].name = this.viewpoints[e.viewpointId].name;
                    i++;
                }
            });
            // console.log(sortedList);
            sortedList = _.sortBy(sortedList, [
                (o) => {
                    return o.name.toLowerCase();
                },
            ]);
            return sortedList;
        }
    }

    // get list item
    private getLists(item): any {
        // console.log(this.state)
        // console.log(this.cfvLists);
        return this.getCfvLists[item];
    }

    // map to a new list to display the information properly
    // this is because the resultList model does not have definition on choices, viewpoints and factors
    // but works perfectly lol

    // get the proper col heading base on the item param item
    getHeaders(item) {
        let headers: any[] = [
            { text: 'List Name', value: 'name', sortable: true, width: 160 },
            {
                text: 'Number of ' + item.name + 's',
                value: 'numChoices',
                sortable: true,
                width: 160,
            },
            { text: 'Action', value: 'actions', width: 160 },
        ];

        return headers;
    }
    deleteshow = false;
    itemToDelete: any;
    // delete click popup
    deleteItem(item) {
        // console.log(item);
        // console.log('show delete dialog');
        this.dialogDelTitle = 'Delete list - ' + item.name;
        this.dialogDelMsg =
            'Are you sure you want to delete ' + item.name + '?\nYou cannot undo this operation.';
        this.itemToDelete = item;
        this.deleteshow = true;
    }

    delCancel() {
        this.deleteshow = false;
        this.itemToDelete = {};
    }
    getListId(item) {
        // console.log(item.listId);
        return item.listId;
    }

    delConfirm() {
        this.deleteshow = false;
        // console.log(this.itemToDelete);
        this.delList(this.itemToDelete);
        // console.log('del confirm');
        // implementation of delete list function, probably vuex module
    }
    private async delList(list: ResourceList) {
        if (this.selectedDecision && list.listId) {
            await VIEWPOINT_API.deleteList(this.selectedDecision.decisionId, list.listId)
                .then((res: any) => {
                    decisionsModule.getDecisionLists();
                })
                .catch((error: any) => {
                    this.alert = true;
                    this.alertType = 'error';
                    this.alertText = 'Delete Failed';
                    this.createAlert();
                });
            // this.displayCreatedLists();
            switch (list.type) {
                case 'CHOICE':
                    workspaceModule.removeActiveChoiceList(list.listId);
                    break;
                case 'FACTOR':
                    workspaceModule.removeActiveFactorList(list.listId);
                    break;
                case 'VIEWPOINT':
                    workspaceModule.removeActiveViewpointList(list.listId);
                    break;
            }
        }
    }
    private createAlert() {
        setTimeout(() => {
            this.alert = false;
        }, 4000);
    }

    private getDelTitle(item: any) {
        return 'Delete list - ' + item.name;
    }

    private getText(item: any) {
        return (
            'Are you sure you want to delete ' + item.name + '?\nYou cannot undo this operation.'
        );
    }

    private save(list: string) {
        this.loading = true;
        if (list === 'Factor') {
            this.factorSave = true;
        } else if (list === 'Choice') {
            this.choiceSave = true;
        } else if (list === 'Viewpoint') {
            this.viewpointSave = true;
        }
    }

    private close(list: string) {
        if (list === 'Factor') {
            this.factorClear = true;
        } else if (list === 'Choice') {
            // this.$refs.choiceEditor.submit();
            this.choiceClear = true;
        } else if (list === 'Viewpoint') {
            this.viewpointClear = true;
        }
        this.showEditor[list] = false;
    }

    @Watch('singularChoiceLabel')
    private onChangeSingularChoiceLabel() {
        this.items[0].name = this.singularChoiceLabel
    }

    @Watch('singularViewpointLabel')
    private onChangeSingularViewpointLabel() {
        this.items[2].name = this.singularViewpointLabel
    }
    /*
     *   Kathy: following codes are no longer needed
     *   the decision list are now pulled from vuex decision module
     */
    // get choiceLists2() {
    //     let choiceList = this.lists
    //         .filter((list: ResourceList) => list.type === 'CHOICE')
    //         .map((list: any) => {
    //             list['numChoices'] = list.choices.length;
    //             return list;
    //         });
    //     console.log(choiceList);
    //     return choiceList;
    // }

    // REST API call
    // //
    // private async fetchLists() {
    //     if (this.selectedDecision) {
    //         decisionsModule.getDecisionLists().then(res=>{
    //             console.log(res);
    //         });
    //     }

    //         this.loading = true;
    //         this.lists = _.values(decisionsModule.decisionLists);
    //         //     await VIEWPOINT_API.getDecisionLists(
    //         //         this.selectedDecision.decisionId
    //         //     ).then((res) => {
    //         //         this.lists = res;
    //         this.cfvLists['Choice'] = this.lists.filter(
    //             (list: ResourceList) => list.type === 'CHOICE'
    //         );
    //         this.cfvLists['Viewpoint'] = this.lists.filter(
    //             (list: ResourceList) => list.type === 'VIEWPOINT'
    //         );
    //         this.cfvLists['Factor'] = this.lists.filter(
    //             (list: ResourceList) => list.type === 'FACTOR'
    //         );
    //         //         // console.log(this.lists);
    //         //         this.loading = false;
    //         //     });
    //         // }
    //         // else{
    //         //     console.log("not ready");
    //     // }else{
    //     //     console.log("good morning");
    //     // }
    // }
}
